import * as cnt from './constants';

export const downloadRates = (docId, downloadType) => ({
  type: cnt.DOWNLOAD_RATES_CONTRACT,
  payload: { docId, downloadType },
});
export const init = payload => ({ type: cnt.INIT, payload });
export const updateContractStatus = ({ contractIds, state }) => ({
  type: cnt.CHANGE_CONTRACT_STATUS,
  payload: { contractIds, state },
});
export const openDialog = payload => ({ type: cnt.OPEN_DIALOG, payload });
export const closeDialog = () => ({ type: cnt.CLOSE_DIALOG });
export const updateDialogProps = payload => ({ type: cnt.UPDATE_PROPS_DIALOG, payload });
export const login = payload => ({ type: cnt.LOG_IN, payload });
export const signupFn = () => ({ type: cnt.SIGN_UP });
export const autoLogin = () => ({ type: cnt.AUTO_LOGIN });
export const scheduleDemo = () => ({ type: cnt.SCHEDULE_DEMO });
export const requestEzLoadAction = () => ({ type: cnt.REQUEST_EZ_LOAD });
export const sendRatesAction = payload => ({ type: cnt.SEND_RATES, payload });
export const downloadAllCurrent = () => ({ type: cnt.DOWNLOAD_ALL_CURRENT });
export const downloadAll = () => ({ type: cnt.DOWNLOAD_ALL });
export const downloadAllOutDated = () => ({ type: cnt.DOWNLOAD_ALL_OUTDATED });



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/__storeFiles__/actions.js